// extracted by mini-css-extract-plugin
export var blue = "_2k-g";
export var brand = "_2k-c";
export var darkGrey = "_2k-f";
export var disabled = "_2k-6";
export var disabledSubtle = "_2k-7";
export var error = "_2k-8";
export var green = "_2k-h";
export var grey = "_2k-e";
export var icon = "_2k-0";
export var inherit = "_2k-b";
export var lightGrey = "_2k-d";
export var orange = "_2k-j";
export var pink = "_2k-l";
export var primary = "_2k-1";
export var purple = "_2k-m";
export var quaternary = "_2k-4";
export var quinary = "_2k-5";
export var red = "_2k-k";
export var secondary = "_2k-2";
export var success = "_2k-a";
export var tertiary = "_2k-3";
export var warning = "_2k-9";
export var white = "_2k-n";
export var yellow = "_2k-i";